import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-navigation',
  standalone: true,
  template: '{{ year }}. Todos os direitos reservados.',
  styleUrl: './footer-navigation.component.scss'
})
export class FooterNavigationComponent {
  year = new Date().getFullYear();
}
